import Swiper from 'swiper/bundle'

export const initNextDepartures = () => {
  document.querySelectorAll('.next-departures').forEach(section => {
    const el = section.querySelector('.js-departures-swiper')
    if (!el || el.swiper) return

    new Swiper(el, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: section.querySelector('.js-departures-prev'),
        nextEl: section.querySelector('.js-departures-next'),
      },
      breakpoints: {
        600: { slidesPerView: 2, spaceBetween: 16 },
        1000: { slidesPerView: 3, spaceBetween: 16 },
        1200: { slidesPerView: 4, spaceBetween: 16 },
      },
    })
  })
}
